import React, { useContext } from 'react'
import { Cart } from 'chemistry'
import { TranslateContext } from 'client/common/translator'

const AddToCartButton = ({ productIds = [], onCartClick }) => {
  const t = useContext(TranslateContext)
  const bundleHref = `/cart/add/${productIds.join('_')}`
  return (
    <a className='bundle-add-to-cart-button' href={bundleHref} onClick={onCartClick}>
      <span>{t('lister.bundle.add_to_cart')}</span>
      <Cart boxSize='20px' color='white' />
    </a>
  )
}

export default AddToCartButton
